/**
 * Creates a style object for background images
 * @param {string} imgPath - The path to the image
 * @returns {Object} Style object with backgroundImage property
 */
export const getBackgroundImgStyle = imgPath => {
  return {
    backgroundImage: imgPath ? `url('${imgPath}')` : 'none'
  };
}; 